import { render, staticRenderFns } from "./shopTips.vue?vue&type=template&id=676fac5e&scoped=true"
import script from "./shopTips.vue?vue&type=script&lang=js"
export * from "./shopTips.vue?vue&type=script&lang=js"
import style0 from "./shopTips.vue?vue&type=style&index=0&id=676fac5e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676fac5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676fac5e')) {
      api.createRecord('676fac5e', component.options)
    } else {
      api.reload('676fac5e', component.options)
    }
    module.hot.accept("./shopTips.vue?vue&type=template&id=676fac5e&scoped=true", function () {
      api.rerender('676fac5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shopTips.vue"
export default component.exports